import { getFirestoreData, updateFirestoreWithOneObject } from 'store/actions/firestoreActions.jsx'
import moment from "moment"
import { db, firebase } from "firebase/fbConfig.js"

// Get User
export const startSetUser = (userObj, user) => {   
  return (dispatch) => {
    if (!userObj.email || !userObj.groups || !userObj.termGroups){
      userObj = {
        ...userObj,
        email: user.email,
        groups: [],
        termGroups: []
      }   
      updateUser(userObj, user.uid)
    }  
    dispatch(setUser(userObj))
  }
}

export const setUser = (userObj) => ({
  type: 'SET_USER',
  userObj
})

export const updateUser = (userObj, uid, firstName, lastName, vendorID) => { 
  db.collection("TEST-users").doc(uid).set({
    ...userObj,
    name: (userObj.firstName ? userObj.firstName : firstName) + " " + (userObj.lastName ? userObj.lastName : lastName),
    updatedAt: new Date()
  }, { merge: true }).then(() => {
    db.collection("TEST-users").doc(uid).set({
      ...userObj,
      name: (userObj.firstName ? userObj.firstName : firstName) + " " + (userObj.lastName ? userObj.lastName : lastName),
      updatedAt: new Date()
    }, { merge: true }).then(() => {
      window.location.reload() 
    }).catch((err) => {
      return (`Update TEST-users with id: ${uid} with error: ${err}`)
    })
  }).catch((err) => {
    return (`Update TEST-users with id: ${uid} with error: ${err}`)
  })
}


export const updateVendor = (userObj, uid) => { 
  db.collection("TEST-vendors").doc(uid).set({
    ...userObj,
    updatedAt: new Date()
  }, { merge: true }).then(() => {
    window.location.reload() 
  }).catch((err) => {
    return (`Update TEST-users with id: ${uid} with error: ${err}`)
  })
}

export const updateShipper = (userObj, uid) => { 
  db.collection("TEST-shippers").doc(uid).set({
    ...userObj,
    updatedAt: new Date()
  }, { merge: true }).then(() => {
    window.location.reload() 
  }).catch((err) => {
    return (`Update TEST-users with id: ${uid} with error: ${err}`)
  })
}

export const addNewVendor = (userObj, uid) => { 
  db.collection("TEST-vendors").doc().set({
    ...userObj,
    updatedAt: new Date()
  }, { merge: true }).then(() => {
    window.location.reload() 
  }).catch((err) => {
    return (`Update TEST-users with id: ${"GET ID!"} with error: ${err}`)
  })
}


export const addNewShipper = (userObj, uid) => { 
  db.collection("TEST-shippers").doc().set({
    ...userObj,
    updatedAt: new Date()
  }, { merge: true }).then(() => {
    window.location.reload() 
  }).catch((err) => {
    return (`Update TEST-users with id: ${"GET ID!"} with error: ${err}`)
  })
}

export const addNewTruck = (obj, id) => { 
  db.collection("TEST-vendors").doc(id).collection("trucks").doc().set({
    ...obj,
    updatedAt: new Date()
  }, { merge: true }).then(() => {
    window.location.reload() 
  }).catch((err) => {
    return (`Update TEST-users with id: ${"GET ID!"} with error: ${err}`)
  })
}

export const addNewTrailer = (obj, id) => { 
  db.collection("TEST-vendors").doc(id).collection("trailers").doc().set({
    ...obj,
    updatedAt: new Date()
  }, { merge: true }).then(() => {
    window.location.reload() 
  }).catch((err) => {
    return (`Update TEST-users with id: ${"GET ID!"} with error: ${err}`)
  })
}

export const addNewUser = (user, id, type, name) => { 
  db.collection(`TEST-${type}`).doc(id).collection("users").doc(user.id).set({
    id: user.id,
    name: user.name,
    email: user.email,
    cell: user.cell ? user.cell : (user.directPhone ? user.directPhone : null),
    updatedAt: new Date()
  }, { merge: true }).then(() => {
    db.collection("TEST-users").doc(user.id).collection("entities").doc(id).set({
      id: id,
      type: type,
      name: name,
      email: user.email,
      cell: user.cell ? user.cell : (user.directPhone ? user.directPhone : null),
      updatedAt: new Date()
  })}).then(() => {
    db.collection("TEST-users").doc(user.id).collection(`${type}`).doc(id).set({
      id: id,
      type: type,
      name: name,
      email: user.email,
      cell: user.cell ? user.cell : (user.directPhone ? user.directPhone : null),
      updatedAt: new Date()
  })}).then(() => {
    db.collection("TEST-users").doc(user.id).set({
      shipperID: id,
        shipperUpdatedAt: new Date()
  }, { merge: true })}).then(() => {
    window.location.reload() 
  }).catch((err) => {
    return (`Update TEST-users with id: ${"GET ID!"} with error: ${err}`)
  })
}


// WEBPACK FOOTER //
// ./src/store/actions/profileActions.jsx